function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export const referralInvites = () => {
  return `${apiBaseUrl()}/api/v2/referral/invites`;
}



// WEBPACK FOOTER //
// ./src/features/referrals/apiUrls.js